"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { isAdFree } from "@/lib/ad-free";
import { useAuth } from "@/app/contexts/AuthContext";
declare global {
  interface Window {
    nitroAds?: {
      createAd: (id: string, config: Record<string, unknown>) => Promise<unknown>;
    };
  }
}

/** The site's single ad unit: the dashboard-configured "scnp-anchor"
 * floating bottom anchor. The head stub queues this call if the loader
 * hasn't arrived yet, and data-spa="auto" keeps it fresh across
 * client-side navigations. Config mirrors the placement builder output. */
export default function NitroAnchor() {
  const $ = _c(7);
  const pathname = usePathname();
  const {
    user,
    loading
  } = useAuth();
  let t0;
  if ($[0] !== loading || $[1] !== pathname || $[2] !== user?.supporter?.active) {
    t0 = isAdFree(pathname) || loading || Boolean(user?.supporter?.active);
    $[0] = loading;
    $[1] = pathname;
    $[2] = user?.supporter?.active;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const adFree = t0;
  let t1;
  let t2;
  if ($[4] !== adFree) {
    t1 = () => {
      if (adFree) {
        return;
      }
      window.nitroAds?.createAd("scnp-anchor", {
        format: "anchor-v2",
        anchor: "bottom",
        anchorBgColor: "rgb(0 0 0 / 80%)",
        anchorClose: true,
        anchorPersistClose: false,
        anchorStickyOffset: 0,
        mediaQuery: "(min-width: 0px)",
        report: {
          enabled: true,
          icon: true,
          wording: "Report Ad",
          position: "top-right"
        }
      });
    };
    t2 = [adFree];
    $[4] = adFree;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  return null;
}